import React, { useEffect, useState } from 'react';
import { AlertRule } from '../../domain/platform/apiContracts';
import { apiService } from '../../domain/platform/apiService';

const AlertsPanel: React.FC = () => {
  const [rules, setRules] = useState<AlertRule[]>([]);
  const [metric, setMetric] = useState('Revenue');
  const [operator, setOperator] = useState<'gt' | 'lt' | 'eq'>('gt');
  const [threshold, setThreshold] = useState(1000);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setRules(await apiService.listAlerts());
  };

  useEffect(() => {
    load();
  }, []);

  const createRule = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    await apiService.createAlert({ metric, operator, threshold, channel: 'in_app' });
    await load();
    setLoading(false);
  };

  return (
    <section className="panel-surface coming-soon-panel">
      <h2>Alerts</h2>
      <p>Create threshold-based monitoring rules for KPI reliability.</p>

      <form onSubmit={createRule} style={{ marginTop: '16px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        <input value={metric} onChange={(e) => setMetric(e.target.value)} placeholder="Metric" />
        <select value={operator} onChange={(e) => setOperator(e.target.value as 'gt' | 'lt' | 'eq')}>
          <option value="gt">&gt;</option>
          <option value="lt">&lt;</option>
          <option value="eq">=</option>
        </select>
        <input type="number" value={threshold} onChange={(e) => setThreshold(Number(e.target.value))} />
        <button type="submit" className="primary-button" disabled={loading}>{loading ? 'Saving...' : 'Add Alert'}</button>
      </form>

      <div style={{ marginTop: '16px' }}>
        {rules.map((rule) => (
          <div key={rule.id} className="quality-operation">
            <strong>{rule.metric}</strong> {rule.operator} {rule.threshold} ({rule.channel})
          </div>
        ))}
        {rules.length === 0 && <div className="muted">No alerts configured yet.</div>}
      </div>
    </section>
  );
};

export default AlertsPanel;
